'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { DEFAULT_LISTING_PART_VARIANTS, LISTING_URL_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { type ListingType } from '@/features/listing/types/listing-types';
import SearchPlaceSelect from '@/features/place/components/search-place-select/search-place-select';
import { type Place } from '@/features/place/types/place-types';
import placeNameToUrl from '@/features/place/utils/place-name-to-url';
import { useRouter } from '@/i18n/routing';
import CitiesGallerySection from '@/sections/cities-gallery/components/cities-gallery-section/cities-gallery-section';
import styles from './reviews-search-place.module.scss';
import { ROUTER_LINKS } from "@/shared/constants/links-constants";
interface ReviewsSearchPlaceProps {
  currentPlace: Place | null;
  listingType: ListingType;
}
export default function ReviewsSearchPlace(props) {
  const $ = _c(19);
  const {
    currentPlace,
    listingType
  } = props;
  const router = useRouter();
  const reviewsPageTranslates = useTranslations("page.info-content-pages.reviews");
  const citiesTranslates = useTranslations("home.cities");
  const listingTypeVariant = LISTING_URL_PART_VARIANTS[listingType];
  const defaultListingType = DEFAULT_LISTING_PART_VARIANTS[listingTypeVariant];
  let t0;
  if ($[0] !== defaultListingType || $[1] !== router) {
    t0 = place => {
      if (place) {
        const redirectSearchResultsLink = ROUTER_LINKS.searchResults(defaultListingType, placeNameToUrl(place.fullName));
        router.push(redirectSearchResultsLink);
      }
    };
    $[0] = defaultListingType;
    $[1] = router;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleSelectChange = t0;
  let t1;
  if ($[3] !== reviewsPageTranslates) {
    t1 = reviewsPageTranslates("search");
    $[3] = reviewsPageTranslates;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <h3 className={styles.reviewsSearchPlace_title}>{t1}</h3>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== currentPlace || $[8] !== handleSelectChange) {
    t3 = <div className={styles.reviewsSearchPlace_searchBox}><SearchPlaceSelect currentPlace={currentPlace} onChangeSelect={handleSelectChange} onShowNearMeClick={handleSelectChange} variant="square" /></div>;
    $[7] = currentPlace;
    $[8] = handleSelectChange;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== citiesTranslates || $[11] !== listingType) {
    t4 = citiesTranslates("search", {
      serviceType: citiesTranslates(listingType)
    });
    $[10] = citiesTranslates;
    $[11] = listingType;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== t4) {
    t5 = <div className={styles.reviewsSearchPlace_popularCities}><CitiesGallerySection title={t4} /></div>;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t2 || $[16] !== t3 || $[17] !== t5) {
    t6 = <div className={styles.reviewsSearchPlace}>{t2}{t3}{t5}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
}